import { render } from "./RoadmapSection.vue?vue&type=template&id=038db981&scoped=true"
import script from "./RoadmapSection.vue?vue&type=script&lang=js"
export * from "./RoadmapSection.vue?vue&type=script&lang=js"

import "./RoadmapSection.vue?vue&type=style&index=0&id=038db981&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038db981"]])

export default __exports__